export const APP_CONFIG_STORAGE_KEY = "tc_application_config";

export type BannerConfig = {
  message?: string;
  startDate?: string;
  endDate?: string;
};

export type FeatureFlagsMap = Record<string, boolean>;

export type ApplicationConfig = {
  bannerConfig?: BannerConfig;
  googleMapsApiKey?: string;
  featureFlags?: FeatureFlagsMap;
};

export function readCachedConfig(): ApplicationConfig | null {
  try {
    const raw = sessionStorage.getItem(APP_CONFIG_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function writeCachedConfig(
  nextConfig: ApplicationConfig | null | undefined
) {
  try {
    sessionStorage.setItem(
      APP_CONFIG_STORAGE_KEY,
      JSON.stringify(nextConfig ?? {})
    );
  } catch {
    // Ignore quota / private-mode failures; in-memory config still works.
  }
}

export function clearCachedConfig() {
  try {
    sessionStorage.removeItem(APP_CONFIG_STORAGE_KEY);
  } catch {
    // no-op
  }
}
